import React from "react";

function LinkedInIcon({
  startColor = "#004d00",
  endColor = "#00e600",
  size = "w-8 h-8",
}) {
  const gradientId = `shareIconGradient-${startColor}-${endColor}`;

  return (
    <svg
      className={size}
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={startColor} />
          <stop offset="100%" stopColor={endColor} />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradientId})`}
        d="M472,480h-79.991c-19.375,0-35.523-13.758-39.211-32.04
c-0.273,0-0.523,0.039-0.797,0.039V303.205c0-17.242-14.328-31.196-31.999-31.196c-17.672,0-32,13.954-32,31.196v136.38v0.43
c0,9.758-3.648,18.547-9.438,25.508c-3.18,4.813-8.609,7.985-14.805,7.985c-9.812,0-17.758-7.946-17.758-17.759
c0-5.188,2.258-9.812,5.828-13.062c2.586-2.852,4.18-6.547,4.18-10.673v-22.875V376.2v-74.487c0-34.079,28.648-61.713,63.992-61.713
c35.343,0,64.007,27.634,64.007,61.713v107.426c0,1.148-0.109,2.141-0.18,3.195c0.055-0.016,0.125-0.016,0.18-0.039v19.719
c0,8.829,7.156,15.985,16,15.985H464c8.844,0,16-7.156,16-15.985V288.01c0-1.203-0.141-2.352-0.391-3.478
C475.5,215.046,420.017,159.99,352.001,159.99c-28.234,0-54.233,9.578-75.358,25.657c-0.078-0.039-0.164-0.023-0.328,0.102
c-2.148,1.727-4.859,2.75-7.812,2.75c-6.914,0-12.492-5.602-12.492-12.508c0-0.859-0.051-1.305-0.141-1.43
c-0.738-8.149-7.52-14.571-15.859-14.571h-48.007c-17.668,0-32.003,14.336-32.003,32.009v240.015c0,1.438,0.254,2.821,0.609,4.142
c-0.375,1.148-0.609,2.422-0.609,3.859c0,22.086-17.902,39.985-40.004,39.985h-2.926H40.003C17.922,480,0,462.101,0,440.015V167.99
c0-22.086,17.922-39.985,40.003-39.985h40.004c26.496,0,47.988-21.493,47.988-48.01c0-26.516-21.492-48.009-47.988-48.009
c-26.512,0-48.003,21.493-48.003,48.009c0,8.844-7.156,16-16.004,16c-8.824,0-16-7.156-16-16C0,35.806,35.824,0,80.007,0
c44.187,0,79.992,35.806,79.992,79.995c0,4.055-0.395,8-0.984,11.899c-0.129,0.75-0.199,1.523-0.344,2.273
c-0.699,3.891-1.648,7.719-2.906,11.391c-0.051,0.18-0.141,0.344-0.195,0.523c-2.762,7.946-6.691,15.305-11.66,21.907
c-14.586,19.391-37.746,32.001-63.902,32.001H48.003c-8.844,0-16,7.18-16,16v256.023c0,8.829,7.156,15.985,16,15.985h80.8
c-0.52-2.586-0.809-5.242-0.809-7.984V191.999c0-35.345,28.668-63.994,64.007-63.994h56.007c9.883,0,18.867,3.641,25.836,9.617
c0.086,0.055,0.172-0.039,0.266,0.031c2.797,2.406,6.422,3.844,10.391,3.844c2.188,0,4.266-0.43,6.148-1.227
c0.57-0.25,0.914-0.211,1.242-0.172c18.578-7.609,38.78-12.094,60.108-12.094c82.938,0,151.124,63.111,159.194,143.911
c0.539,2.602,0.805,5.328,0.805,8.094v160.006C512,462.101,494.102,480,472,480L472,480z M208.006,447.999c8.824,0,16,7.172,16,16
c0,8.845-7.175,16.001-16,16.001c-8.844,0-16.004-7.156-16.004-16.001C192.002,455.171,199.163,447.999,208.006,447.999
L208.006,447.999z"
      />
    </svg>
  );
}

export default LinkedInIcon;
